/**
 * Sanitizes a URL to prevent XSS via javascript: or other dangerous protocols.
 * Returns the URL if it uses a safe protocol, otherwise returns '#'.
 */
const SAFE_URL_PATTERN = /^(https?:\/\/|data:image\/)/i;
export function sanitizeUrl(url) {
    if (!url)
        return '#';
    const trimmed = url.trim();
    if (SAFE_URL_PATTERN.test(trimmed))
        return trimmed;
    return '#';
}
/**
 * Sanitizes a URL for use in img src attributes.
 * Allows https, http, data:image, and blob: protocols.
 */
const SAFE_IMG_SRC_PATTERN = /^(https?:\/\/|data:image\/|blob:)/i;
export function sanitizeImgSrc(url) {
    if (!url)
        return '';
    const trimmed = url.trim();
    if (SAFE_IMG_SRC_PATTERN.test(trimmed))
        return trimmed;
    return '';
}
//# sourceMappingURL=sanitizeUrl.js.map